import awaitToJs from 'await-to-js'
import {
  SET_SEGMENTS_USER,
  SET_SEGMENTS_EDIT,
  ALERT_COLORS,
  MESSAGE_ERROR,
  ALERT_DELAY,
} from '@App/constantes'
import Fetch from '@App/helpers/fetch'
import { setAlertBox } from '@App/actions/snackbar'
import { API_URL } from '@App/configs/rest'

const fetGetSegmentsUsers = new Fetch()

export const setEditSegment = (segments: any) => {
  return {
    type: SET_SEGMENTS_EDIT,
    payload: segments,
  }
}

export const setSegmentUser = (segments: any) => {
  return {
    type: SET_SEGMENTS_USER,
    payload: segments,
  }
}

export const getSegmentUser = () => {
  return async (dispatch: any) => {
    const [err, data] = await awaitToJs(fetGetSegmentsUsers.get({
      url: `${API_URL}/applications/segments`,
      params: null,
      headers: {},
    }))
    if (!err && data) {
      dispatch(setSegmentUser(data))

      return data
    }

    if (err) {
      dispatch(setAlertBox({
        title: err && err.message || MESSAGE_ERROR,
        background: ALERT_COLORS.red,
        delay: ALERT_DELAY,
      }))

      return err
    }
  }
}
